var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Partnerlogin")]),_c('h4',[_vm._v(_vm._s(_vm.$t("login")))]),_c('p',{staticClass:"widget-auth-info"},[_vm._v(" "+_vm._s(_vm.$t("useYourEmailToLogin"))+" ")]),_c('login-form',{attrs:{"redirect-route":"partnerdashboard"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }